import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "maz-ui/styles";
import "@/styles/index.scss";
import "remixicon/fonts/remixicon.css";
import VueCookies from "vue3-cookies";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";

// iOS Safari pinch-zooms the page whatever the viewport says; a native app
// doesn't. Its gesture events are stopped so two fingers don't zoom or shake
// the app. Other browsers honour the viewport and the html touch-action.
for (const type of ["gesturestart", "gesturechange", "gestureend"]) {
  document.addEventListener(type, (e) => e.preventDefault(), { passive: false });
}

// Meetings no longer use a socket: the browser joins a LiveKit server with a
// token from the API (src/live/session.js).
createApp(App)
  .use(store)
  .use(router)
  .use(VueCookies)
  .use(VueToast)
  .mount("#app");
